import { render, staticRenderFns } from "./bgbox.vue?vue&type=template&id=076f9c36&scoped=true"
import script from "./bgbox.vue?vue&type=script&lang=js"
export * from "./bgbox.vue?vue&type=script&lang=js"
import style0 from "./bgbox.vue?vue&type=style&index=0&id=076f9c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f9c36",
  null
  
)

export default component.exports